import React from "react"
import { useSelector } from "react-redux"
import { PriceDetailContent } from "components/molecules/price"

interface props {
  canvasId: string
  middleChartFlag?: boolean
  numberOfStocks?: number
  oneLineType?: boolean
  movingDataItem?: {
    active: number
    changeData: Function
    total: number
    setFlag?: Function
  }
}

const ChartPriceDetail = React.memo((props: props) => {
  const {
    canvasId,
    numberOfStocks,
    middleChartFlag,
    oneLineType,
    movingDataItem,
  } = props
  const symbolDetailSelector = (state: any) =>
    state.chart[canvasId].symbolDetail
  const symbolDetail = useSelector(symbolDetailSelector)

  return (
    <PriceDetailContent
      data={symbolDetail}
      middleChartFlag={middleChartFlag}
      numberOfStocks={numberOfStocks}
      oneLineType={oneLineType}
      movingDataItem={movingDataItem}
    />
  )
})

export default ChartPriceDetail
